import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  styled,
  TextField,
  Tooltip,
  Typography,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Paper,
  Container,
  Grid,
  Stack,
  Fade,
  Zoom,
  Slide,
  Alert,
  Skeleton,
  Snackbar
} from "@mui/material";
import {
  Close as CloseIcon,
  Help as HelpIcon,
  School as SchoolIcon,
  Person as PersonIcon,
  PlayArrow as PlayArrowIcon,
  Schedule as ScheduleIcon,
  Link as LinkIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Groups as GroupsIcon,
  VideoLibrary as VideoLibraryIcon,
  MenuBook as MenuBookIcon,
  Storage as StorageIcon,
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  Money,
  AttachMoney,
  ContentCopy,
  RocketLaunch
} from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/search.svg";
import { ReactComponent as EditIcon } from "../../assets/edit.svg";
import { ReactComponent as UsersIcon } from "../../assets/users.svg";
import { ReactComponent as GlobalIcon } from "../../assets/global.svg";
import CallMadeIcon from "@mui/icons-material/CallMade";
import AddIcon from "@mui/icons-material/Add";
import TrainingTable from "../Tables/TrainingTable";
import AddTraining from "../Modals/AddTraining";
import { setLimit, setPage } from "../../features/mod/modSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCoaches,
  getAllLevelDetails,
  getAllTrainings,
  createMasterclass,
  getAllMasterclasses,
  updateMasterclass,
  getAllMasterclassTrainings,
  getAllSharedMasterclassTrainings,
  deleteMasterclass
} from "../../features/training/trainingSlice";
import {
  selectAvailableCoaches,
  selectCurrentPage,
  selectLevelDetails,
  selectLimit,
  selectMasterclasses
} from "../../features/training/trainingSelectors";
import getInitials from "../../utils/getInitials";
import useSignedUrl from "../../utils/useSignedUrl";
import {
  deleteTraining,
  updateCommunityLink,
  updateCommunityLinkForMasterclassApi
} from "../../api/trainingApi";
import { Close, Help, People, School } from "@mui/icons-material";
import FAQModal from "../Modals/FAQModal";
import CreateMasterclassModal from "../Modals/AddMasterclass";
import AddMasterclassTraining from "../Modals/AddMasterclassTraining";
import MasterclassTrainingTable from "../Tables/MasterclassTrainingTable";
import { getAdditionalBundleCouponPurchase } from "../../api/userApi";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const StyledTextFieldContainer = styled(Box)(({ theme }) => ({
  position: "relative"
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
    background: "#FCFCFC",
    "& input[type=number]": {
      "-moz-appearance": "textfield"
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& fieldset": {
      color: "#9CA3AF",
      borderColor: "#D1D5DB"
    },
    "&.Mui-focused fieldset": {
      borderColor: "#D1D5DB"
    }
  }
}));

const Masterclass = ({ setIsAddingMasterclass, isAddingMasterclass }) => {
  const [searchValue, setSearchValue] = React.useState("");
  const [scheduleDate, setScheduleDate] = React.useState("");
  const [editData, setEditData] = React.useState(null);
  const [currentCoach, setCurrentCoach] = React.useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(null);
  const [editLinkModal, setEditLinkModal] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedMasterclass, setSelectedMasterclass] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTrainingType, setSelectedTrainingType] = useState("Overview");
  const [isAddingMasterclassTraining, setIsAddingMasterclassTraining] =
    useState(false);
  const [masterclassTrainingEditData, setMasterclassTrainingEditData] =
    useState(null);
  const buttonRef = useRef(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loadingBtn, setLoadingBtn] = React.useState(null);

  const currentAdmin = useSelector((state) => state.adminauth.admin);
  const [selectedLevel, setSelectedLevel] = React.useState(
    currentAdmin?.adminUserId ? "level1" : ""
  );

  const availableCoaches = useSelector(selectAvailableCoaches) || [];
  const availableLevels = useSelector(selectLevelDetails) || [];
  const masterclasses = useSelector(selectMasterclasses) || [];
  const dispatch = useDispatch();
  const pageNumber = useSelector(selectCurrentPage);
  const limit = useSelector(selectLimit);
  const [openFAQModal, setOpenFAQModal] = useState();

  // Fetch masterclasses
  useEffect(() => {
    if (currentAdmin?.adminUserId) {
      dispatch(
        getAllMasterclasses({
          search: searchValue,
          page: 0,
          limit: 150
        })
      );
    }
  }, [dispatch, searchValue, currentAdmin?.adminUserId]);
  useEffect(() => {
    if (selectedMasterclass && selectedTrainingType) {
      if (selectedTrainingType === "Overview")
        dispatch(
          getAllMasterclassTrainings({
            masterclassId: selectedMasterclass._id,
            type: selectedTrainingType,
            page: pageNumber,
            limit
          })
        );
      else {
        dispatch(
          getAllSharedMasterclassTrainings({
            masterclassType: selectedMasterclass?.type,
            type: selectedTrainingType,
            page: pageNumber,
            limit
          })
        );
      }
    }
  }, [dispatch, selectedMasterclass, selectedTrainingType, pageNumber, limit]);
  useEffect(() => {
    if (currentAdmin?.adminUserId)
      if (!searchValue || searchValue?.length > 3)
        dispatch(
          getAllTrainings({
            search: searchValue,
            level: selectedLevel,
            page: pageNumber,
            limit
          })
        );
  }, [
    dispatch,
    searchValue,
    selectedLevel,
    confirmDeleteModal,
    isAddingMasterclass,
    currentCoach,
    pageNumber,
    limit
  ]);

  useEffect(() => {
    dispatch(getAllCoaches());
  }, [dispatch]);

  useEffect(() => {
    if (!currentAdmin?.adminUserId) {
      setCurrentCoach(currentAdmin?.referenceId);
    }
  }, [currentAdmin]);

  useEffect(() => {
    if (!isAddingMasterclass)
      dispatch(
        getAllLevelDetails(
          !currentAdmin?.adminUserId ? currentAdmin?.referenceId : currentCoach
        )
      );
  }, [isAddingMasterclass, dispatch, currentCoach, currentAdmin?.adminUserId]);

  const handleDelete = async (id) => {
    await deleteTraining(id);
    setConfirmDeleteModal(null);
  };

  const handleCreateMasterclass = async (formData) => {
    try {
      setLoading(true);
      if (formData.id) {
        await dispatch(updateMasterclass(formData));
      } else {
        await dispatch(createMasterclass(formData));
      }

      setShowCreateModal(false);
      setEditData(null);
      dispatch(getAllMasterclasses({ page: 0, limit: 150 }));
      setSelectedMasterclass(null);
    } catch (error) {
      console.error("Error saving masterclass:", error);
    } finally {
      setLoading(false);
    }
  };
  const CodeDisplay = ({ masterclass }) => {
    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopy = (code, index) => {
      navigator.clipboard.writeText(code);
      setCopiedIndex(index);

      // Reset the tooltip after 2 seconds
      setTimeout(() => {
        setCopiedIndex(null);
      }, 2000);
    };

    const codes =
      masterclass.type === "coaches"
        ? [
            `MASTERCLASS-${masterclass._id}-Coach-Full_${masterclass.bundleAmount}_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Coach-Partial_${
              masterclass.twoSplitAmount || masterclass.splitAmount || 0
            }_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Coach-ThreeSplit_${
              masterclass.threeSplitAmount || 0
            }_UPGRADE`
          ]
        : masterclass.type === "individual"
        ? [
            // `MASTERCLASS-${masterclass._id}-Affiliate_${masterclass.bundleAmount}_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Individual-Full_${masterclass.bundleAmount}_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Individual-Partial_${
              masterclass.twoSplitAmount || masterclass.splitAmount || 0
            }_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Individual-ThreeSplit_${
              masterclass.threeSplitAmount || 0
            }_UPGRADE`
          ]
        : [
            `MASTERCLASS-${masterclass._id}-Accelerator-Full_${masterclass.bundleAmount}_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Accelerator-Partial_${
              masterclass.twoSplitAmount || masterclass.splitAmount || 0
            }_UPGRADE`,
            `MASTERCLASS-${masterclass._id}-Accelerator-ThreeSplit_${
              masterclass.threeSplitAmount || 0
            }_UPGRADE`
          ];

    return (
      <Box mb={2}>
        <Chip label="Codes" size="medium" sx={{ mb: 1 }} />
        <Box display="flex" flexDirection="column" gap={1}>
          {codes.map((code, index) => (
            <Paper
              key={index}
              variant="outlined"
              sx={{
                p: 1.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f9f9f9"
              }}
            >
              <Typography
                variant="body2"
                sx={{ wordBreak: "break-all", fontFamily: "monospace" }}
              >
                {code}
              </Typography>
              <Tooltip
                title={copiedIndex === index ? "Copied!" : "Copy to clipboard"}
                arrow
              >
                <IconButton
                  onClick={() => handleCopy(code, index)}
                  size="small"
                >
                  <ContentCopy fontSize="small" />
                </IconButton>
              </Tooltip>
            </Paper>
          ))}
        </Box>
      </Box>
    );
  };

  const MasterclassCard = ({ masterclass }) => {
    const isActive = masterclass.isActive;
    const startDate = dayjs.utc(masterclass.startDate).format("MM/DD/YYYY");
    const endDate = dayjs.utc(masterclass.endDate).format("MM/DD/YYYY");
    const isSelected = selectedMasterclass?._id === masterclass._id;
    const currentDate = dayjs.utc().format("YYYY-MM-DD");
    const handleCheckout = async (priceId) => {
      try {
        // POST to your backend API that creates a Checkout Session
        const res = await getAdditionalBundleCouponPurchase(
          priceId,
          currentDate
        );
        const url = await res?.stripeCheckoutLink;
        await navigator.clipboard.writeText(url);
        setSnackbarMessage("Stripe checkout URL copied to clipboard!");
        setOpenSnackbar(true);
      } catch (err) {
        console.error(err);
      } finally {
      }
    };
    return (
      <Card
        sx={{
          position: "relative",
          border: isSelected ? "3px solid" : "1px solid",
          borderColor: isSelected ? "primary.main" : "grey.300",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderRadius: 3,
          overflow: "visible",
          background: isSelected
            ? "linear-gradient(135deg, #f3f4f6 0%, #ffffff 100%)"
            : "linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            borderColor: isSelected ? "primary.dark" : "primary.light"
          }
        }}
        onClick={() => {
          setSelectedMasterclass(masterclass);
          setSelectedTrainingType("Overview");
        }}
      >
        {/* Status Badge */}
        <Box
          sx={{
            position: "absolute",
            top: -8,
            left: 20,
            zIndex: 10
          }}
        >
          <Chip
            icon={
              isActive ? (
                <CheckCircleIcon
                  style={{ color: "white", backgroundColor: "success.main" }}
                />
              ) : (
                <RadioButtonUncheckedIcon />
              )
            }
            label={isActive ? "Active" : "Inactive"}
            size="small"
            sx={{
              backgroundColor: isActive ? "success.main" : "grey.400",
              color: "white",
              fontWeight: 600,
              boxShadow: 2
            }}
          />
        </Box>

        {/* Edit Button */}
        <IconButton
          sx={{
            position: "absolute",
            top: 12,
            right: 8,
            zIndex: 10,
            backgroundColor: "background.paper",
            border: "2px solid",
            borderColor: "grey.200",
            width: 40,
            height: 40
          }}
          onClick={(e) => {
            e.stopPropagation();
            setEditData(masterclass);
            setShowCreateModal(true);
          }}
        >
          <EditIcon
            style={{ color: "grey.600", "&:hover": { color: "white" } }}
            fontSize="small"
          />
        </IconButton>
        <IconButton
          sx={{
            position: "absolute",
            top: 12,
            right: 52,
            zIndex: 10,
            backgroundColor: "background.paper",
            border: "2px solid",
            borderColor: "grey.200",
            width: 40,
            height: 40
          }}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(deleteMasterclass(masterclass?._id));
            dispatch(getAllMasterclasses({ page: 0, limit: 150 }));
          }}
        >
          <DeleteIcon
            style={{ color: "red", "&:hover": { color: "white" } }}
            fontSize="small"
          />
        </IconButton>

        <CardContent sx={{ p: 3, pt: 4 }}>
          {/* Header Section */}
          <Box mb={3}>
            <Typography
              variant="h5"
              fontWeight={700}
              color="text.primary"
              sx={{
                mb: 1,
                background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}
            >
              {masterclass.title}
            </Typography>

            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <Chip
                icon={
                  masterclass.type === "individuals" ? (
                    <PersonIcon />
                  ) : masterclass.type === "coaches" ? (
                    <SchoolIcon />
                  ) : (
                    <RocketLaunch />
                  )
                }
                label={
                  masterclass.type === "individuals"
                    ? "Individuals"
                    : masterclass.type === "coaches"
                    ? "Coaches"
                    : "Accelerator"
                }
                size="medium"
                sx={{
                  backgroundColor:
                    masterclass.type === "individuals"
                      ? "rgba(25, 118, 210, 0.1)"
                      : masterclass.type === "coaches"
                      ? "rgba(156, 39, 176, 0.1)"
                      : "rgba(18, 118, 43, 0.1)",
                  color:
                    masterclass.type === "individuals"
                      ? "primary.main"
                      : masterclass.type === "coaches"
                      ? "secondary.main"
                      : "success.main",
                  fontWeight: 600,
                  "& .MuiChip-icon": {
                    color: "inherit"
                  }
                }}
              />
              {isSelected && (
                <Chip
                  icon={<VisibilityIcon style={{ color: "white" }} />}
                  label="Selected"
                  size="medium"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: 600
                  }}
                />
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
              gap={1}
              mb={2}
            >
              <Chip
                icon={<AttachMoney />}
                label={"One time Amount: " + masterclass.bundleAmount}
                size="medium"
                sx={{
                  backgroundColor: "rgba(170, 173, 176, 0.1)",
                  color: "#0c0c0c",
                  fontWeight: 600,
                  "& .MuiChip-icon": {
                    color: "inherit"
                  }
                }}
              />
              {masterclass.type === "coaches" ? (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Coach-Full_${masterclass.bundleAmount}_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              ) : masterclass.type === "individual" ? (
                <Box display={"flex"} gap={1} flexDirection={"column"}>
                  {/* <Button
                    sx={{
                      backgroundColor: "#6c6a6aff",
                      textTransform: "none",
                      padding: "3px 6px",
                      fontSize: "small"
                    }}
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckout(
                        `MASTERCLASS-${masterclass._id}-Affiliate_${masterclass.bundleAmount}_UPGRADE`
                      );
                    }}
                  >
                    Copy Affiliate Link
                  </Button> */}
                  <Button
                    sx={{
                      backgroundColor: "#6c6a6aff",
                      textTransform: "none",
                      padding: "3px 6px",
                      fontSize: "small"
                    }}
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckout(
                        `MASTERCLASS-${masterclass._id}-Individual-Full_${masterclass.bundleAmount}_UPGRADE`
                      );
                    }}
                  >
                    Copy Link
                  </Button>
                </Box>
              ) : (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Accelerator-Full_${masterclass.bundleAmount}_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
              gap={1}
              mb={2}
            >
              <Chip
                icon={<AttachMoney />}
                label={"Two Split Amount: " + (masterclass.splitAmount || 0)}
                size="medium"
                sx={{
                  backgroundColor: "rgba(170, 173, 176, 0.1)",
                  color: "#0c0c0c",
                  fontWeight: 600,
                  "& .MuiChip-icon": {
                    color: "inherit"
                  }
                }}
              />
              {masterclass.type === "coaches" ? (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Coach-Partial_${
                        masterclass.splitAmount || 0
                      }_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              ) : masterclass.type === "individual" ? (
                <Box display={"flex"} gap={1} flexDirection={"column"}>
                  {/* <Button
                    sx={{
                      backgroundColor: "#6c6a6aff",
                      textTransform: "none",
                      padding: "3px 6px",
                      fontSize: "small"
                    }}
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckout(
                        `MASTERCLASS-${masterclass._id}-Affiliate_${masterclass.bundleAmount}_UPGRADE`
                      );
                    }}
                  >
                    Copy Affiliate Link
                  </Button> */}
                  <Button
                    sx={{
                      backgroundColor: "#6c6a6aff",
                      textTransform: "none",
                      padding: "3px 6px",
                      fontSize: "small"
                    }}
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckout(
                        `MASTERCLASS-${masterclass._id}-Individual-Partial_${
                          masterclass.splitAmount || 0
                        }_UPGRADE`
                      );
                    }}
                  >
                    Copy Link
                  </Button>
                </Box>
              ) : (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Accelerator-Partial_${
                        masterclass.splitAmount || 0
                      }_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
              gap={1}
              mb={2}
            >
              <Chip
                icon={<AttachMoney />}
                label={"Three Split Amount: " + (masterclass.threeSplitAmount || 0)}
                size="medium"
                sx={{
                  backgroundColor: "rgba(170, 173, 176, 0.1)",
                  color: "#0c0c0c",
                  fontWeight: 600,
                  "& .MuiChip-icon": {
                    color: "inherit"
                  }
                }}
              />
              {masterclass.type === "coaches" ? (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Coach-ThreeSplit_${
                        masterclass.splitAmount || 0
                      }_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              ) : masterclass.type === "individual" ? (
                <Box display={"flex"} gap={1} flexDirection={"column"}>
                  <Button
                    sx={{
                      backgroundColor: "#6c6a6aff",
                      textTransform: "none",
                      padding: "3px 6px",
                      fontSize: "small"
                    }}
                    variant="contained"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckout(
                        `MASTERCLASS-${masterclass._id}-Individual-ThreeSplit_${
                          masterclass.splitAmount || 0
                        }_UPGRADE`
                      );
                    }}
                  >
                    Copy Link
                  </Button>
                </Box>
              ) : (
                <Button
                  sx={{
                    backgroundColor: "#6c6a6aff",
                    textTransform: "none",
                    padding: "3px 6px",
                    fontSize: "small"
                  }}
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckout(
                      `MASTERCLASS-${masterclass._id}-Accelerator-ThreeSplit_${
                        masterclass.splitAmount || 0
                      }_UPGRADE`
                    );
                  }}
                >
                  Copy Link
                </Button>
              )}
            </Box>
            <CodeDisplay masterclass={masterclass} />
          </Box>

          {/* Duration Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 3,
              backgroundColor: "grey.50",
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.200"
            }}
          >
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <ScheduleIcon color="primary" fontSize="small" />
              <Typography
                variant="subtitle2"
                fontWeight={600}
                color="text.primary"
              >
                Program Duration
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {startDate} → {endDate}
            </Typography>
          </Paper>

          {/* Level Information */}
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              color="text.primary"
              mb={2}
              display="flex"
              alignItems="center"
              gap={1}
            >
              <MenuBookIcon color="primary" fontSize="small" />
              Level Start Dates
            </Typography>

            <Stack spacing={1}>
              {[
                {
                  label: "800g Challenge",
                  date: masterclass.level1_start_date,
                  color: "success"
                },
                {
                  label: "Lazy Macros",
                  date: masterclass.level2_start_date,
                  color: "warning"
                },
                {
                  label: "Three Pillars Method",
                  date: masterclass.level3_start_date,
                  color: "info"
                }
              ].map((level, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: `${level.color}.50`,
                    border: "1px solid",
                    borderColor: `${level.color}.200`
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    color="text.primary"
                  >
                    {level.label}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={500}
                  >
                    {dayjs.utc(level.date).format("MM/DD/YYYY")}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        </CardContent>
      </Card>
    );
  };

  return !isAddingMasterclass ? (
    <Box>
      {/* Header Section */}
      {currentAdmin?.adminUserId && (
        <Box
          display="flex"
          maxHeight="48px"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
        >
          <Box display="flex" gap={2} alignItems="center">
            <Typography variant="h5" fontWeight={600} color="#374151">
              Active Masterclasses
            </Typography>
          </Box>
          <Box display="flex" gap={2} height="100%" alignItems="center">
            <Button
              startIcon={<AddIcon />}
              sx={{
                fontSize: "14px",
                padding: "12px 24px",
                background: "#1976d2",
                border: "1px solid #1976d2",
                color: "#fff",
                fontWeight: 700,
                textTransform: "none",
                height: "48px",
                borderRadius: 2
              }}
              onClick={() => setShowCreateModal(true)}
              variant="contained"
            >
              Create Masterclass
            </Button>
          </Box>
        </Box>
      )}

      {/* Masterclass Overview Section */}
      {currentAdmin?.adminUserId && (
        <Box mb={4}>
          {masterclasses.length > 0 ? (
            <Box
              display="grid"
              gridTemplateColumns="repeat(auto-fill, minmax(350px, 1fr))"
              gap={3}
            >
              {masterclasses.map((masterclass) => (
                <MasterclassCard
                  key={masterclass._id}
                  masterclass={masterclass}
                />
              ))}
            </Box>
          ) : (
            <Card
              sx={{ textAlign: "center", p: 4, border: "1px dashed #D1D5DB" }}
            >
              <Typography variant="h6" color="#6B7280" mb={2}>
                No Masterclasses Found
              </Typography>
              <Typography variant="body2" color="#9CA3AF" mb={3}>
                Create your first masterclass to get started
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setShowCreateModal(true)}
                sx={{ backgroundColor: "#1976d2", textTransform: "none" }}
              >
                Create Masterclass
              </Button>
            </Card>
          )}
        </Box>
      )}

      {/* Selected Masterclass Details */}
      {selectedMasterclass && (
        <Box mb={4}>
          <Typography variant="h5" fontWeight={600} color="#374151" mb={3}>
            {selectedMasterclass.title} - Details
          </Typography>

          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))"
            gap={3}
          >
            {availableLevels?.map(
              ({ levelName: level, totalUsers, title, faq }, index) => (
                <Card key={index} sx={{ border: "1px solid #E5E7EB" }}>
                  <CardContent sx={{ p: 3 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                    >
                      <Typography variant="h6" fontWeight={600} color="#374151">
                        {title}
                      </Typography>
                      <IconButton
                        onClick={() =>
                          setEditLinkModal({
                            link: selectedMasterclass?.link?.[level],
                            level
                          })
                        }
                        sx={{
                          padding: 1,
                          border: "1px solid #D1D5DB",
                          borderRadius: 1
                        }}
                      >
                        <EditIcon height={16} width={16} />
                      </IconButton>
                    </Box>

                    {/* <Box display="flex" alignItems="center" gap={1} mb={2}>
                      <UsersIcon height={16} width={16} />
                      <Typography variant="body2" color="#6B7280">
                        {totalUsers} users
                      </Typography>
                    </Box> */}

                    {selectedMasterclass?.link?.[level] && (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Tooltip
                          title={selectedMasterclass?.link?.[level]}
                          arrow
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#368AD0",
                              textDecoration: "underline",
                              cursor: "pointer",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "200px"
                            }}
                            onClick={() => {
                              const link = selectedMasterclass?.link?.[level];
                              const url = link.startsWith("http")
                                ? link
                                : `http://${link}`;
                              window.open(url, "_blank");
                            }}
                          >
                            {selectedMasterclass?.link?.[level]}
                          </Typography>
                        </Tooltip>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const link = selectedMasterclass?.link?.[level];
                            const url = link.startsWith("http")
                              ? link
                              : `http://${link}`;
                            window.open(url, "_blank");
                          }}
                          sx={{ ml: 1 }}
                        >
                          <CallMadeIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              )
            )}
          </Box>
        </Box>
      )}

      {selectedMasterclass && (
        <Box mb={4}>
          <Typography variant="h5" fontWeight={600} color="#374151" mb={3}>
            Training Categories
          </Typography>

          <Box display="flex" gap={2} mb={3}>
            {selectedMasterclass.type === "accelerator" ? (
              <Button
                variant={
                  selectedTrainingType === "Overview" ? "contained" : "outlined"
                }
                onClick={() => setSelectedTrainingType("Overview")}
                sx={{
                  backgroundColor:
                    selectedTrainingType === "Overview"
                      ? "#1976d2"
                      : "transparent",
                  color:
                    selectedTrainingType === "Overview" ? "white" : "#1976d2",
                  borderColor: "#1976d2"
                }}
              >
                Masterclass Overview
              </Button>
            ) : selectedMasterclass.type === "individuals" ? (
              <>
                <Button
                  variant={
                    selectedTrainingType === "Overview"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setSelectedTrainingType("Overview")}
                  sx={{
                    backgroundColor:
                      selectedTrainingType === "Overview"
                        ? "#1976d2"
                        : "transparent",
                    color:
                      selectedTrainingType === "Overview" ? "white" : "#1976d2",
                    borderColor: "#1976d2"
                  }}
                >
                  Masterclass Overview
                </Button>
                <Button
                  variant={
                    selectedTrainingType === "10Principles"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setSelectedTrainingType("10Principles")}
                  sx={{
                    backgroundColor:
                      selectedTrainingType === "10Principles"
                        ? "#1976d2"
                        : "transparent",
                    color:
                      selectedTrainingType === "10Principles"
                        ? "white"
                        : "#1976d2",
                    borderColor: "#1976d2"
                  }}
                >
                  10 Principles of Nutrition
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant={
                    selectedTrainingType === "Overview"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setSelectedTrainingType("Overview")}
                  sx={{
                    backgroundColor:
                      selectedTrainingType === "Overview"
                        ? "#1976d2"
                        : "transparent",
                    color:
                      selectedTrainingType === "Overview" ? "white" : "#1976d2",
                    borderColor: "#1976d2"
                  }}
                >
                  Masterclass Overview
                </Button>
                <Button
                  variant={
                    selectedTrainingType === "10Principles"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setSelectedTrainingType("10Principles")}
                  sx={{
                    backgroundColor:
                      selectedTrainingType === "10Principles"
                        ? "#1976d2"
                        : "transparent",
                    color:
                      selectedTrainingType === "10Principles"
                        ? "white"
                        : "#1976d2",
                    borderColor: "#1976d2"
                  }}
                >
                  10 Principles of Nutrition
                </Button>
                <Button
                  variant={
                    selectedTrainingType === "CoachesVault"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => setSelectedTrainingType("CoachesVault")}
                  sx={{
                    backgroundColor:
                      selectedTrainingType === "CoachesVault"
                        ? "#1976d2"
                        : "transparent",
                    color:
                      selectedTrainingType === "CoachesVault"
                        ? "white"
                        : "#1976d2",
                    borderColor: "#1976d2"
                  }}
                >
                  Coaches Vault
                </Button>
              </>
            )}
          </Box>

          {/* Add Training Button */}
          <Box display="flex" justifyContent="flex-end" mb={3}>
            <Button
              ref={buttonRef}
              startIcon={<AddIcon />}
              onClick={() => {
                setIsAddingMasterclassTraining(true);
                if (buttonRef.current) {
                  const yOffset = -100; // scroll 100px above the button
                  const y =
                    buttonRef.current.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;

                  setTimeout(
                    () => window.scrollTo({ top: y, behavior: "smooth" }),
                    200
                  );
                }
              }}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                "&:hover": { backgroundColor: "#1565c0" }
              }}
            >
              Add{" "}
              {selectedTrainingType === "10Principles"
                ? "10 Principles"
                : selectedTrainingType === "CoachesVault"
                ? "Coaches Vault"
                : selectedTrainingType}{" "}
              Training
            </Button>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={1000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* Create Masterclass Modal */}
      <CreateMasterclassModal
        open={showCreateModal}
        onClose={() => {
          setShowCreateModal(false);
          setEditData(null);
        }}
        onSubmit={handleCreateMasterclass}
        editData={editData}
        loading={loading}
      />

      {/* FAQ Modal */}
      <FAQModal
        levelName={openFAQModal?.level}
        userId={currentCoach}
        htmlValue={openFAQModal?.faq}
        open={!!openFAQModal?.level}
        onClose={() => setOpenFAQModal(null)}
      />

      {/* Training Table */}
      {!selectedMasterclass ? (
        <></>
      ) : isAddingMasterclassTraining ? (
        <AddMasterclassTraining
          selectedMasterclass={selectedMasterclass}
          selectedTrainingType={selectedTrainingType}
          setIsAddingMasterclassTraining={setIsAddingMasterclassTraining}
          editData={masterclassTrainingEditData}
          setEditData={setMasterclassTrainingEditData}
        />
      ) : (
        <MasterclassTrainingTable
          selectedMasterclass={selectedMasterclass}
          selectedTrainingType={selectedTrainingType}
          setIsAddingMasterclassTraining={setIsAddingMasterclassTraining}
          setEditData={setMasterclassTrainingEditData}
        />
      )}

      {/* Edit Link Modal */}
      <Modal
        open={!!editLinkModal}
        onClose={() => setEditLinkModal(null)}
        closeAfterTransition
      >
        <Fade in={!!editLinkModal}>
          <Paper
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 500 },
              borderRadius: 3,
              overflow: "hidden"
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white"
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <LinkIcon />
                  <Typography variant="h5" fontWeight={600}>
                    Edit Community Link
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => setEditLinkModal(null)}
                  sx={{ color: "white" }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Content */}
            <Box p={4}>
              <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
                Update the community chat link for this level
              </Alert>

              <TextField
                fullWidth
                variant="outlined"
                label="Community Link"
                placeholder="https://community.example.com/..."
                value={editLinkModal?.link || ""}
                onChange={(e) =>
                  setEditLinkModal({ ...editLinkModal, link: e.target.value })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LinkIcon color="primary" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  mb: 3,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2
                  }
                }}
              />

              <Button
                fullWidth
                variant="contained"
                size="large"
                onClick={async () => {
                  await updateCommunityLinkForMasterclassApi(
                    selectedMasterclass?._id,
                    editLinkModal?.level,
                    editLinkModal?.link
                  );
                  setEditLinkModal(null);

                  const response = await dispatch(
                    getAllMasterclasses({ page: 0, limit: 150 })
                  );

                  // Extract the updated masterclass by ID from the response
                  const updatedList = response.payload.masterclasses || [];
                  const updated = updatedList.find(
                    (mc) => mc._id === selectedMasterclass._id
                  );

                  setSelectedMasterclass(updated);
                }}
                sx={{
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                }}
              >
                Update Link
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={!!confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(null)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            width: { xs: "90%", sm: "550px" }
          }}
        >
          <Box display="flex" justifyContent="flex-end">
            <IconButton onClick={() => setConfirmDeleteModal(null)}>
              <Close />
            </IconButton>
          </Box>
          <Box mb={3} px={2} textAlign="center">
            <Typography fontSize={"24px"} fontWeight={600}>
              Are you sure you want to delete?
            </Typography>
            <Typography fontSize={"14px"} color="text.secondary" mt={1}>
              This change cannot be undone and may impact users.
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" px={2} gap={2}>
            <Button
              variant="outlined"
              onClick={() => setConfirmDeleteModal(null)}
              sx={{
                flex: 1,
                padding: "10px 0",
                borderColor: "grey.400",
                color: "grey.600"
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDelete(confirmDeleteModal)}
              sx={{
                flex: 1,
                padding: "10px 0",
                color: "white",
                background: "#E94545"
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  ) : (
    <AddTraining
      scheduleDate={scheduleDate}
      setIsAddingMasterclass={setIsAddingMasterclass}
      editData={editData}
    />
  );
};

export default Masterclass;
